import { MessageCircle } from 'lucide-react'
import { useChatPanel } from '@/shared/hooks/useMobileMenu'

export function FloatingChatButton() {
  const { openChat } = useChatPanel()

  return (
    <button
      onClick={openChat}
      className="fixed bottom-4 right-4 z-50 min-w-[56px] min-h-[56px] p-4 rounded-xl bg-[#1a1a1a] hover:bg-[#252525] border border-white/15 hover:border-white/30 shadow-xl shadow-black/40 hover:shadow-2xl hover:shadow-blue-500/20 transition-all duration-200 active:scale-95 touch-manipulation"
      aria-label="Open chat"
      title="Open chat (⌘⇧K)"
    >
      <MessageCircle size={26} className="text-white/90 hover:text-white" />
    </button>
  )
}
